import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Absence } from 'src/app/_model/Absence';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {WfCompleteRequest} from "../../_model/request/WfCompleteRequest";
import {RequestService} from "../../_services/request.service";

@Component({
    selector: 'app-requestsCancel',
    templateUrl: './requestsCancelSelected.component.html',
    styleUrls: ['./requestsCancelSelected.component.css'],
    standalone: true,
        imports: [
            MatDialogModule
        ]
})
export class RequestsCancelSelectedComponent implements OnInit {
    request:WfCompleteRequest=new WfCompleteRequest();
    currentUser: User;
    constructor(public dialogRef: MatDialogRef<RequestsCancelSelectedComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence[],
                private authService: AuthenticationService,
                private requestService: RequestService,
                private toastr: ToastrService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
    }
    cancelSelected(){

        this.data.forEach(element => {
            this.request.id=element.id;
            this.request.description=element.description;
            this.requestService.cancelRequest(this.request).subscribe(result => {
                this.toastr.success('İptal işlemi başarılı', '');
                this.dialogRef.close();
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        });
    }
}
